import { render, staticRenderFns } from "./Chotot.vue?vue&type=template&id=788bd244&"
import script from "./Chotot.vue?vue&type=script&lang=js&"
export * from "./Chotot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports